import type { ReactNode } from 'react';
import { RichTextFormatter, translate, translateFormatter } from '@/core/localization/translate';
export const {
  loyaltyProgramBronze,
  loyaltyProgramSilver,
  loyaltyProgramGold,
  loyaltyProgramFromToday,
  loyaltyProgramFlashPromos,
  loyaltyProgramPrivateSells,
  loyaltyProgramCart,
  loyaltyProgramAfterSalesService,
  loyaltyProgramHighest,
  loyaltyProgramAdvantagesPromos,
  loyaltyProgramAdvantagesPrivateSells,
  loyaltyProgramAdvantagesCart,
  loyaltyProgramAdvantagesAfterSalesService,
  loyaltyProgramNew,
  loyaltyProgramDetailsAllProBenefits
} = translate({
  "loyaltyProgramBronze": "Bronze",
  "loyaltyProgramSilver": "Silver",
  "loyaltyProgramGold": "Gold",
  "loyaltyProgramFromToday": "Right away",
  "loyaltyProgramFlashPromos": "\u2022 Flash offers",
  "loyaltyProgramPrivateSells": "\u2022 Private sales",
  "loyaltyProgramCart": "\u2022 Express basket",
  "loyaltyProgramAfterSalesService": "\u2022 Service apr\xE8s-vente r\xE9serv\xE9",
  "loyaltyProgramHighest": "Congratulations! You are now a GOLD Pro",
  "loyaltyProgramAdvantagesPromos": "Flash offers on the app all year round",
  "loyaltyProgramAdvantagesPrivateSells": "Exclusive private sales",
  "loyaltyProgramAdvantagesCart": "Express basket: call us and we'll prepare your basket in under 2 hours. Quick and easy.",
  "loyaltyProgramAdvantagesAfterSalesService": "Un service apr\xE8s-vente qui vous est r\xE9serv\xE9",
  "loyaltyProgramNew": "New",
  "loyaltyProgramDetailsAllProBenefits": "Discover all your Pro rewards"
});
export const loyaltyProgramGoldStatus = translateFormatter<{
  icon: ReactNode;
}>([{
  "type": 0,
  "value": "Votre status "
}, {
  "type": 1,
  "value": "icon"
}, {
  "type": 0,
  "value": " Or"
}], undefined, undefined, "en");
export const loyaltyProgramLevelTitle = translateFormatter<{
  count: number;
  nextLevel: string;
  proBadge: ReactNode;
}>([{
  "type": 6,
  "value": "count",
  "options": {
    "=1": {
      "value": [{
        "type": 0,
        "value": "Plus que "
      }, {
        "type": 1,
        "value": "count"
      }, {
        "type": 0,
        "value": " achat* pour devenir "
      }, {
        "type": 1,
        "value": "proBadge"
      }, {
        "type": 0,
        "value": " "
      }, {
        "type": 1,
        "value": "nextLevel"
      }]
    },
    "other": {
      "value": [{
        "type": 0,
        "value": "Plus que "
      }, {
        "type": 1,
        "value": "count"
      }, {
        "type": 0,
        "value": " achats* pour devenir "
      }, {
        "type": 1,
        "value": "proBadge"
      }, {
        "type": 0,
        "value": " "
      }, {
        "type": 1,
        "value": "nextLevel"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");
export const loyaltyProgramGoldTitle = translateFormatter<{
  proBadge: ReactNode;
}>([{
  "type": 0,
  "value": "Congratulations! You are a Pro in "
}, {
  "type": 1,
  "value": "proBadge"
}, {
  "type": 0,
  "value": " Gold"
}], undefined, undefined, "en");
export const loyaltyProgramPriceCondition = translateFormatter<{
  price: JSX.Element;
}>([{
  "type": 0,
  "value": "*Up to "
}, {
  "type": 1,
  "value": "price"
}, {
  "type": 0,
  "value": " HT."
}], undefined, undefined, "en");
export const loyaltyProgramDescription = translateFormatter<{
  strong: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Your "
}, {
  "type": 8,
  "value": "strong",
  "children": [{
    "type": 0,
    "value": "free"
  }]
}, {
  "type": 0,
  "value": " loyalty program, just for Pros"
}], undefined, undefined, "en");
export const loyaltyProgramGetNextLevel = translateFormatter<{
  numberOfPurchases: number;
}>([{
  "type": 0,
  "value": "From "
}, {
  "type": 1,
  "value": "numberOfPurchases"
}, {
  "type": 0,
  "value": " orders onwards*"
}], undefined, undefined, "en");
export const loyaltyProgramCashbackPercentage = translateFormatter<{
  percentage: number;
}>([{
  "type": 1,
  "value": "percentage"
}, {
  "type": 0,
  "value": "% cashback with every purchase"
}], undefined, undefined, "en");
export const remainingPurchasesForNextLevel = translateFormatter<{
  count: number;
  nextLevel: string;
  strong: RichTextFormatter;
}>([{
  "type": 6,
  "value": "count",
  "options": {
    "=1": {
      "value": [{
        "type": 0,
        "value": "You're almost a "
      }, {
        "type": 1,
        "value": "nextLevel"
      }, {
        "type": 0,
        "value": " Pro. "
      }, {
        "type": 1,
        "value": "count"
      }, {
        "type": 0,
        "value": " "
      }, {
        "type": 8,
        "value": "strong",
        "children": [{
          "type": 0,
          "value": "order*"
        }]
      }, {
        "type": 0,
        "value": " to go!"
      }]
    },
    "other": {
      "value": [{
        "type": 0,
        "value": "You're almost a "
      }, {
        "type": 1,
        "value": "nextLevel"
      }, {
        "type": 0,
        "value": " Pro. "
      }, {
        "type": 1,
        "value": "count"
      }, {
        "type": 0,
        "value": " "
      }, {
        "type": 8,
        "value": "strong",
        "children": [{
          "type": 0,
          "value": "orders*"
        }]
      }, {
        "type": 0,
        "value": " to go!"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");
export const currentLevelAdvantagesTitle = translateFormatter<{
  levelBadge: ReactNode;
}>([{
  "type": 0,
  "value": "Benefits at this level "
}, {
  "type": 1,
  "value": "levelBadge"
}, {
  "type": 0,
  "value": " :"
}], undefined, undefined, "en");
export const loyaltyProgramTitle = translateFormatter<{
  proBadge: ReactNode;
  span: RichTextFormatter;
}>([{
  "type": 1,
  "value": "proBadge"
}, {
  "type": 0,
  "value": " Pro Club"
}], undefined, undefined, "en");
export const loyaltyProgramMinimumPurchase = translateFormatter<{
  price: JSX.Element;
}>([{
  "type": 0,
  "value": "* On orders over "
}, {
  "type": 1,
  "value": "price"
}, {
  "type": 0,
  "value": " excl. VAT"
}], undefined, undefined, "en");